// extracted by mini-css-extract-plugin
module.exports = {"content":"PageNotFound_content__2zlt5"};